export default "__VITE_ASSET__957cfe7c__"